import React, { ReactNode } from 'react';
import { ChevronRightIcon } from '../Icon';
import { IIconLinkProps, StyledIconLink } from './IconLink';
import { LinkText } from './LinkText';

export interface IChevronRightLinkProps extends IIconLinkProps {
	children: ReactNode;
}

export function ChevronRightLink({
	children,
	...rest
}: IChevronRightLinkProps) {
	return (
		<StyledIconLink {...rest}>
			<LinkText>{children}</LinkText>
			<ChevronRightIcon />
		</StyledIconLink>
	);
}
